import { useState, useEffect } from "react";
import { ThemeProviderV2 } from '@blueprint/ui';
import { useSelector } from "react-redux";

import { Loader, toast, toastError } from "../../common/components/core";
import { currentRolesSelector } from "../../redux/slices/auth/selectors";
import { SuperAdminRole, superAdminAccountType } from "../../types/superadmin";
import { FormSubmissionHandler } from "../../types/common";
import { UserProfileRelationship } from "../../types/relationship";
import { PageTitle } from "../../types/pageTitle";
import relationshipApi from "../../api/relationship";
import RelationshipList from "./components/RelationshipList";
import { RelationshipFormValues } from "./components/RelationshipForm"


const RelationshipView = (): JSX.Element => {
    document.title = PageTitle.DeveloperView;

    const currentRoles = useSelector(currentRolesSelector);
    const accountType = superAdminAccountType(currentRoles);
    const [relationshipList, setRelationshipList] = useState<UserProfileRelationship[]>([]);
    const [isRelationshipListLoading, setIsRelationshipListLoading] = useState(false);
    const [ temp, setTemp ] = useState<UserProfileRelationship | null>(null);

    const getRelationshipList = async () => {
        try {
            setIsRelationshipListLoading(true);
            const relationships = await relationshipApi.list();
            setRelationshipList(relationships);
            setIsRelationshipListLoading(false);
        } catch (e) {
            console.error(e);
            setIsRelationshipListLoading(false);
        }
    };
    useEffect(() => {

        getRelationshipList();
        return () => {
            setIsRelationshipListLoading(false)
        };
    }, []);

    const handleSubmit: FormSubmissionHandler<RelationshipFormValues> = async (
        values,
    ) => {
        setIsRelationshipListLoading(true);
        try {
            await relationshipApi.saveOrUpdate(values);
            const name = JSON.parse(values.developer).name;
            toast(`Developer '${name}' updated`);
            setTemp(null);
        } catch (e) {
            toastError("Unknown error occurred!");
            setTemp(null);
        }
        await getRelationshipList();
        setIsRelationshipListLoading(false);
    }
    return (
        <ThemeProviderV2>
        <Loader isLoading={isRelationshipListLoading}>
            {accountType && relationshipList &&
                <PureRelationshipView
                    relationships={relationshipList}
                    accountType={accountType}
                    onSubmit={handleSubmit}
                    temp={temp}
                    setTemp={setTemp}
                />
            }

        </Loader>
    </ThemeProviderV2>
    );
};

type PureRelationshipViewProps = {
    relationships: UserProfileRelationship[];
    accountType: SuperAdminRole;
    onSubmit: FormSubmissionHandler<RelationshipFormValues>;
    temp: UserProfileRelationship | null;
    setTemp: (relationship: UserProfileRelationship | null) => void;
};

export const PureRelationshipView = ({
    relationships,
    accountType,
    onSubmit,
    temp,
    setTemp,
}: PureRelationshipViewProps): JSX.Element => {

    return (
        <>
            <div className="d-flex align-items-center mb-4">
                <h1 className="flex-grow-1 mb-0">Developer Entitlements</h1>
            </div>
            <RelationshipList
                relationships={relationships}
                accountType={accountType}
                onSubmit={onSubmit}
                temp={temp}
                setTemp={setTemp}
            />
        </>
    );
};

export default RelationshipView;
